import React from 'react';
import { Backdrop } from "../../../../imports/muiImport";
import { CircularProgress } from '@mui/material';

function PaymentProcessLoading({ open }) {
    return (
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default PaymentProcessLoading